import { SyncOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OdkSyncCard.css';

const { Meta } = Card;

const OdkSyncCard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Card hoverable className="custom-card" style={{ width: '100%', marginBottom: '16px' }}>
      <div className="card-content">
        <Meta
          avatar={
            <Avatar
              size={48}
              style={{ backgroundColor: '#f6f6f6' }}
              icon={<SyncOutlined style={{ color: 'black' }} />}
            />
          }
          title={<span className="upload-description">{'ODK'}</span>}
        />
        <div className="buttons-container">
          {
            <>
              <Button onClick={() => navigate('/video-source/odk')}>Setting</Button>
              <Button
                onClick={() =>
                  navigate('/video-source/content', {
                    state: { videoSourceType: 'odk' },
                  })
                }
              >
                Manage Sync Videos
              </Button>
            </>
          }
        </div>
      </div>
    </Card>
  );
};

export default OdkSyncCard;
